const { client, loadToken } = require('services/api/client');
export { loadToken };

// export async function getInspectionsByUUID(uuid) {
//     var { data } = await client.get(`/inspections/${uuid}`);
//     return data;
// }

export async function getInspectionsByStopID(stop_id) {
    var { data } = await client.get(`/inspections/stopid/${stop_id}`);
    return data;
}

export async function getInspectionsByUUID(uuid) {
    var { data } = await client.get(`/inspections/uuid/${uuid}`);
    return data;
}

export async function getInspectionByRecordID(inspection_record_id) {
    var { data } = await client.get(`/inspections/record/${inspection_record_id}`);
    return data;
}

export async function getAllInspectionsForUser() {
    var { data } = await client.get(`/inspections`);
    return data;
}

export async function addNewInspection(body) {
    var { data } = await client.post('inspections/new', body, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return data;
}

export async function addNewRectification(body) {
    var { data } = await client.post('inspections/rectify', body, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return data;
}

export async function updateInspectionStatus(inspection_record_id) {
    var { data } = await client.put(`/inspections/record/status/${inspection_record_id}`);
    return data;
}

export async function deleteInspection(inspection_record_id){
    var { data } = await client.put(`/inspections/record/${inspection_record_id}`);
    return data;
}

const all = {
    loadToken, /*getInspectionsByUUID, */addNewInspection, addNewRectification, updateInspectionStatus, getInspectionsByStopID, getInspectionsByUUID, getAllInspectionsForUser, getInspectionByRecordID, deleteInspection//, getInspection
};

export default all;